module.exports = __webpack_public_path__ + "img/premb-r-pm-mobile-2.2c717ef5.svg";